module.exports = "/images/LUIZ_CARLOS_VERGARA.jpg?b923e60bc4aec7b83dbe0d647bc73574";